module.exports = __webpack_public_path__ + "static/fonts/Oswald-Bold.8993e4d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oswald/Oswald-Bold.ttf
// module id = 1166
// module chunks = 5